module.exports = __webpack_public_path__ + "static/media/okrs-2.3145c934.svg";